var _g, _circle, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMarkerLocation2 = function SvgMarkerLocation2(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 43,
    viewBox: "0 0 27 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#a)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 13.635,
    cy: 36.118,
    rx: 11.004,
    ry: 4.076,
    fill: "#000"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 14.384,
    cy: 13.498,
    r: 7.812,
    fill: "#fff"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.043.252C7.301.252 1.816 5.76 1.816 12.53c0 8.51 12.24 23.044 12.24 23.044S26.27 20.622 26.27 12.53C26.27 5.76 20.785.252 14.043.252Zm3.69 15.873a5.19 5.19 0 0 1-3.69 1.532 5.19 5.19 0 0 1-3.689-1.532 5.26 5.26 0 0 1 0-7.409 5.17 5.17 0 0 1 3.69-1.534c1.393 0 2.703.545 3.688 1.534a5.26 5.26 0 0 1 0 7.41Z",
    fill: "#66BBE2"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "a",
    x: 0.631,
    y: 30.042,
    width: 26.008,
    height: 12.151,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }))));
};
export { SvgMarkerLocation2 as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjciIGhlaWdodD0iNDMiIHZpZXdCb3g9IjAgMCAyNyA0MyIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGcgZmlsdGVyPSJ1cmwoI2ZpbHRlcjBfZikiPgo8ZWxsaXBzZSBjeD0iMTMuNjM1IiBjeT0iMzYuMTE3OSIgcng9IjExLjAwNDIiIHJ5PSI0LjA3NTYyIiBmaWxsPSJibGFjayIvPgo8L2c+CjxjaXJjbGUgY3g9IjE0LjM4MzkiIGN5PSIxMy40OTc5IiByPSI3LjgxMTYxIiBmaWxsPSJ3aGl0ZSIvPgo8cGF0aCBkPSJNMTQuMDQzMyAwLjI1MjQ0MUM3LjMwMTQzIDAuMjUyNDQxIDEuODE2NDEgNS43NjAzIDEuODE2NDEgMTIuNTMwMkMxLjgxNjQxIDIxLjAzOTMgMTQuMDU1MyAzNS41NzQ1IDE0LjA1NTMgMzUuNTc0NUMxNC4wNTUzIDM1LjU3NDUgMjYuMjcwMSAyMC42MjA4IDI2LjI3MDEgMTIuNTMwMkMyNi4yNzAxIDUuNzYwMyAyMC43ODUzIDAuMjUyNDQxIDE0LjA0MzMgMC4yNTI0NDFaTTE3LjczMjQgMTYuMTI1MkMxNi43MTUyIDE3LjE0NjQgMTUuMzc5MyAxNy42NTcxIDE0LjA0MzMgMTcuNjU3MUMxMi43MDc0IDE3LjY1NzEgMTEuMzcxMiAxNy4xNDY0IDEwLjM1NDQgMTYuMTI1MkM4LjMyMDE2IDE0LjA4MjcgOC4zMjAxNiAxMC43NTkyIDEwLjM1NDQgOC43MTY0NkMxMS4zMzk0IDcuNzI2OSAxMi42NDk3IDcuMTgxOSAxNC4wNDMzIDcuMTgxOUMxNS40MzY5IDcuMTgxOSAxNi43NDY5IDcuNzI3MTIgMTcuNzMyNCA4LjcxNjQ2QzE5Ljc2NjYgMTAuNzU5MiAxOS43NjY2IDE0LjA4MjcgMTcuNzMyNCAxNi4xMjUyWiIgZmlsbD0iIzY2QkJFMiIvPgo8ZGVmcz4KPGZpbHRlciBpZD0iZmlsdGVyMF9mIiB4PSIwLjYzMDg1OSIgeT0iMzAuMDQyMyIgd2lkdGg9IjI2LjAwODQiIGhlaWdodD0iMTIuMTUxMiIgZmlsdGVyVW5pdHM9InVzZXJTcGFjZU9uVXNlIiBjb2xvci1pbnRlcnBvbGF0aW9uLWZpbHRlcnM9InNSR0IiPgo8L2ZpbHRlcj4KPC9kZWZzPgo8L3N2Zz4K";